<template>
  <div id="koshigaya">
    <v-app-bar color="orange lighten-3" fixed dense>
        <v-toolbar-title>こどもプログラミング教室（越谷）</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <section>
        <v-parallax src="@/assets/image/hero.jpg" height="600">
          <v-layout column align-center justify-center class="white--text">
            <h1 class="white--text mb-2 display-1 text-center blue--text font-weight-black">学ぼう！プログラミング</h1>
            <div class="subheading mb-4 text-center blue--text">〜こどもプログラミング教室〜</div>
            <!-- <v-btn
              class="mt-12 font-weight-bold"
              color="blue lighten-2"
              dark
              large
              href="/pre-made-themes"
            >体験してみる</v-btn> -->
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout column wrap class="my-12" align-center>
          <v-flex xs12 sm4 class="my-4">
            <div class="text-center">
              <h2 class="headline">こどもプログラミング教室って、何？</h2>
              <hr/>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                        <v-avatar
                            tile
                            size="40px">
                            <v-img
                                src="@/assets/image/scratch_icon.png">
                            </v-img>
                        </v-avatar>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">何をやるの？</div>
                    </v-card-title>
                    <v-card-text>
                        全国で数多く行われるようになったプログラミング教室。そのんほとんどで利用されているのが、ビジュアルプログラミング言語<a href="http://scratch.mit.edu/" target="_blank">「Scratch(スクラッチ)」</a>です。<br>
                        こどもプログラミング教室（こどもプログラミング教室）では、小学生を対象に<strong>現役のエンジニア</strong>が教えています。
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="orange--text text--lighten-2">mdi-google-maps</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">いつ・どこでやってる？</div>
                    </v-card-title>
                    <v-card-text>
                        こどもプログラミング教室は以下で開催します。<br/>
                        <strong>開催日：</strong>土・日・祝&nbsp;&nbsp;（午前9:20〜）<br/>
                        <strong>頻度：</strong>月に３回〜５回で不定期に開催<br/>
                        <strong>場所：</strong>
                        <span style="text-decoration:line-through">大相模地区センター<a href="http://google.com/maps/place/@35.884407,139.808489,15z/data=!4m2!3m1!1s0x0:0xbc0630d52c125473?sa=X&ved=2ahUKEwiz3-rfxJnmAhUdK6YKHbUnARsQ_BIwCnoECBYQCA" target="_blank">（Googleマップ）</a></span><br/>
                        <span class="ml-10" style="text-decoration:line-through">（埼玉県越谷市相模町3-42-1）</span><br/>
                        <span class="ml-10"><strong>オンラインでのみ開催（'20.5〜現在）</strong></span><br/>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="orange--text text--lighten-2">mdi-currency-jpy</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">いくらかかるの？</div>
                    </v-card-title>
                    <v-card-text>
                       こどもプログラミング教室は2つのクラスを行なっています。<br/>
                        <strong>対象者は小学生（2年生以上）</strong>です。<br/>
                        <strong class="ml-4">・学習クラス：</strong>1,000円/50分<br/>
                        <strong class="ml-4">・フリークラス：</strong>500円/100分<span class="overline">※</span><br/>
                      <span class="overline">（※：フリークラスの価格は今後改定の可能性があります。</span><br/>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section>
        <v-parallax src="@/assets/image/section.jpg" height="380">
          <v-layout column align-center justify-center>
            <div class="headline brown--text text--darken-3 mb-4 text-center  font-weight-black">どうやって始める？</div>
            <pre class="brown--text text--darken-3 subtitle" >まずは見学か、体験してみてください。</pre>
            <v-btn
              class="mt-12 font-weight-bold"
              color="blue lighten-2"
              dark
              large
              href="https://calendar.google.com/calendar/embed?src=39pih3rdskrfii4chblkasnj78%40group.calendar.google.com"
              target="_blank"
            >見学・体験してみる</v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-container grid-list-xl>




          <v-layout column wrap class="my-12" align-center>
            <v-flex xs12 sm4>

            <div class="text-center">
              <h2 class="headline">こどもプログラミング教室カレンダー</h2>
              <hr/>
            </div>
              <v-card flat class="transparent mt-6">
                  <iframe src="https://calendar.google.com/calendar/embed?height=400&amp;wkst=1&amp;bgcolor=%23ffffff&amp;ctz=Asia%2FTokyo&amp;src=MzlwaWgzcmRza3JmaWk0Y2hibGthc25qNzhAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;src=amEuamFwYW5lc2UjaG9saWRheUBncm91cC52LmNhbGVuZGFyLmdvb2dsZS5jb20&amp;color=%23DD4477&amp;color=%23227F63&amp;showTitle=0&amp;showNav=1&amp;showDate=0&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;showTz=0" style="border-width:0" width="600" height="400" frameborder="0" scrolling="no"></iframe>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout row wrap justify-center class="my-12">
            <v-flex xs12 sm4>
              <v-card flat class="transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">LINE@</div>
                </v-card-title>
                <v-card-text>
                   <a href="http://j.mp/codomoLINE" target="_blank">こどもプログラミング教室のLINE公式アカウント（旧LINE@）</a>です。<br/>
                   ご登録いただくと、教室開催の情報通知を受け取ることができます。
                </v-card-text>
                <div class="d-flex justify-center">
                    <a href="https://lin.ee/4Sj5yTJ"><img src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" alt="友だち追加" height="36" border="0"></a>
                </div>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4 offset-sm1>
              <v-card flat class="transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">お問い合わせ</div>
                </v-card-title>
                <v-card-text>すすむテック！こどもプログラミング教室は、個人である<strong>高松奨</strong>が運営しています。<br/>
                ご質問などはこちらまで</v-card-text>
                <v-list class="transparent d-flex justify-center">
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon class="orange--text text--lighten-2">mdi-email</v-icon>
                    </v-list-item-action>
                    <div>
                      <p>codomo.prog<span class="domain"></span>gmail.com</p>
                    </div>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

    <core-footer/>
    </v-content>
    <Manager />
  </div>
</template>

<script>
export default {
  name: "Koshigaya",

    components: {
        CoreFooter: () => import('@/components/core/Footer'),
    },
    track () {
      this.$ga.page('/')
    }
};
</script>
<style lang="sass">
    // スパム対策
    .domain::before {
        content: '@';
    }
</style>